import { TAction, TActionRequest } from "../../base/types/redux";
import {
  GetListPackageResponse
} from "../utils/types";
import { ACTION_TYPES } from "./actionTypes";

export const getListPackage = (params: any): TActionRequest<any> => {
  return {
    type: ACTION_TYPES.GET_LIST_PACKAGE,
    params,
  };
};

export const setListPackage = (response: GetListPackageResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_LIST_PACKAGE,
    response,
  };
};